import React, { Component } from 'react';

import $ from 'jquery';
import { Animated } from 'react-animated-css';

//  ----------------   Form components
import Form from 'react-validation/build/form';
import Button from 'react-validation/build/button';

//  ----------------   Custom Form components & validations
import { NewPassword, ConfirmPassword, noSpace, required, minChar8, confirmPassword,passwordRegex } from '../formValidation';

import { translate } from 'react-i18next';
import './PassResetForm.css';

class PassResetForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiurl: '',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    const { token } = this.props.match.params; // token value from url params passed by <Route/>

    if (token) {
      const url = `/api/v1/resetPassword/${token}`;
      this.setState({ apiurl: url, token });
    }
  }


  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    if (value) {
      target.parentElement.classList.add('input--filled');
    } else {
      target.parentElement.classList.remove('input--filled');
    }

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const url = this.state.apiurl;
    const token = this.state.token;
    // get data from all field in form
    const passwords = this.form.getValues();
    const data = { token, ...passwords };
    // api call to update password
    $.ajax({
      url: url, // url param ":token" to update password of email associated with this token
      type: 'PUT',
      data: JSON.stringify(data),
      success: function (res) {

        this.props.history.push('/login');
        this.props.notifySuccess(res.message);
      }.bind(this),
      error: function (err) {
        this.props.notifyError(err.responseJSON.message);
      }.bind(this)
    });
  }

  render() {

    const { t } = this.props;
    return (
      <div>
        <Animated className="form-animation" animationIn="fadeInRight" animationOut="fadeOutLeft" isVisible={true}>
          <Form className="PassResetForm" ref={c => { this.form = c }} onSubmit={this.handleSubmit}>
            <h2 className="formTitle text-center">RESET PASSWORD</h2>

            <div className="form-group">
              <NewPassword
                required
                id="password"
                name="password"
                type="password"
                minLength="8"
                className="input__field input__field--madoka"
                t={t}
                validations={[noSpace, required,passwordRegex]}
                onChange={this.handleInputChange} />
            </div>

            <div className="form-group">
              <ConfirmPassword
                required
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                minLength="8"
                className="input__field input__field--madoka"
                onChange={this.handleInputChange}
                t={t}
                validations={[noSpace, required, confirmPassword]} />
            </div>

            <div className="form-group submitGroup form-row text-center">
              <Button type="submit" className="btn btn--submit btn-rounded btn-outline-primary mx-auto">Confirm</Button>
            </div>

          </Form>
        </Animated>
      </div>
    );
  }
}

export default translate('translations')(PassResetForm);



// WEBPACK FOOTER //
// ./src/components/PassResetForm/PassResetForm.js